<template>
  <campaigns-factory
    name="Fundraising"
    :adlabels="['OF-Fundraising']"
  />
</template>

<script>
import CampaignsFactory from '../campaigns-factory/CampaignsFactory'
export default {
  name: 'campaigns-fundraising',
  components: {
    CampaignsFactory
  }
}
</script>
